<avi-dashboard-widget
    class="smart-operations-widget"
    shape="operations"
    status="success"
    [iconSize]="24"
    headerText="{{ l10nKeys.smartOperationsHeader | vtranslate }}"
>
    <div
        dashboardWidgetBody
        class="smart-operations-widget__body"
        *ngrxLet="pulseCloudServiceOrgDashboardsVisibility$ as pulseCloudServiceOrgDashboardsVisibility"
    >
        <span class="smart-operations-widget__label">
            {{ l10nKeys.pulseCloudServiceOrgDashboardsLabel | vtranslate }}
        </span>
        <div
            class="smart-operations-widget__value sel-portal-url"
            [ngClass]="pulseCloudServiceOrgDashboardsVisibility ? 'smart-operations-widget__enabled' : 'smart-operations-widget__deactivated'"
        >
            {{ (pulseCloudServiceOrgDashboardsVisibility ? l10nKeys.enabledLabel : l10nKeys.deactivatedLabel) | vtranslate }}
        </div>
    </div>
</avi-dashboard-widget>
